import { render, staticRenderFns } from "./SingleConfiguration.vue?vue&type=template&id=f4180dd6"
import script from "./SingleConfiguration.vue?vue&type=script&lang=js"
export * from "./SingleConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports